import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '../index'

// 在里面定义的属性相当于state
export interface IMobile {
    // 移动端屏幕竖屏/横屏(0,90/-90) 目前只设置了苹果端会改变
    orientation: number;
    // 其他人员是否展示
    onlineUser: boolean;
}

/**
* dynamic: true: 动态创建动态模块,即new Vuex.Store({})里面不用注册的
* store,当前模块注册到store上
* name: 'user' 命名空间为user
*/
@Module({ dynamic: true, store, name: 'mobile' })

export default class Mobile extends VuexModule implements IMobile {
    // 在里面定义的属性相当于state
    public orientation = 0;
    public onlineUser = false;

    //使用get修饰，代替了以前的getters
    //Action 相当于 axtion, action发出修改数据的指令，在mutation中修改数据

    //@Mutation 相当于 mutation,作为唯一修改数据的途径
    @Mutation
    setOrientation(orientation: number) {
        this.orientation = orientation
    }

    @Mutation
    setOnlineUser(onlineUser: boolean) {
        this.onlineUser = onlineUser
    }

}
//getModule 将模块导出
export const MobileModule = getModule(Mobile)
